// @ts-expect-error
import {OnboardingWelcomeCard} from './dash-grid/cards/onboarding-welcome-card';
import {Funnel} from './dash-grid/dashes/funnel/funnel';
import {Leaderboard} from './dash-grid/dashes/leaderboards/leaderboard';
import {List} from './dash-grid/dashes/lists/list';
// @ts-expect-error
import {ListSummaries} from './dash-grid/dashes/listSummaries/list-summaries';
// @ts-expect-error
import {Metrics} from './dash-grid/dashes/metrics/metrics';
// @ts-expect-error
import {Quotas} from './dash-grid/dashes/quotas/quotas';
import {ACTIVITIES, FEED, TODOS} from './dashboard-constants';
import {DashboardActivities} from './sidebar/activities/activities';
import {DashboardFeed} from './sidebar/feed/feed';
import {DashboardTodos} from './sidebar/todos/todos';

const componentMap = {
    // Dashes
    leaderboard: Leaderboard,
    quotas: Quotas,
    metrics: Metrics,
    list: List,
    listSummaries: ListSummaries,
    funnel: Funnel,
    // Cards
    'onboarding00-dashes': null, // removed. was ./dash-grid/cards/onboarding-card
    'onboarding01-dashes': OnboardingWelcomeCard,
    // Iframe dash is handled directly in dash-grid.js
} as const;

const paneConstants = {
    [ACTIVITIES]: {
        component: DashboardActivities,
    },
    [FEED]: {
        component: DashboardFeed,
    },
    [TODOS]: {
        component: DashboardTodos,
    },
} as const;

/**
 * Structured way to get the correct component type from the type returned
 * via API response.
 * n.b. It is important to keep this separate from the constants themselves
 * which are pulled into the redux store to be certain that we don't pull
 * pull dashboard components into the main `nut.js` bundle.
 *
 * @param  {string} paneName   'id' constant of sidebar pane
 * @return {DashPane}          Dash pane component
 */
export const getComponentForPaneName = (paneName: string) => {
    if (!paneName) return undefined;

    // @ts-expect-error
    return paneConstants[paneName].component;
};

/**
 * Structured way to get the correct component type from the type returned
 * via API response.
 * n.b. It is important to keep this separate from the constants themselves
 * which are pulled into the redux store to be certain that we don't pull
 * pull dashboard components into the main `nut.js` bundle.
 *
 * @param  {string} type       dashboard card type 'id'
 * @return {DashComponent}     Dash card component
 */
export const getDashComponent = (type: string) => {
    if (!type) return undefined;

    // @ts-expect-error
    return componentMap[type];
};
